import { useState, useEffect } from 'react';
import axios from '../../../../api/axios';

/**
 * 收藏功能管理 Hook
 * 负责管理题目的收藏状态
 */
export function useBookmark(questionId, user) {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [toggling, setToggling] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!questionId || !user) return;
    checkBookmarkStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId, user]);

  const checkBookmarkStatus = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/bookmarks/${questionId}/status`);
      setIsBookmarked(response.data.isBookmarked || false);
    } catch (error) {
      console.error('Error checking bookmark status:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleBookmark = async () => {
    if (!user) {
      alert('请先登录');
      return;
    }
    
    setToggling(true);
    try {
      if (isBookmarked) {
        await axios.delete(`/bookmarks/${questionId}`);
        setIsBookmarked(false);
      } else {
        await axios.post(`/bookmarks/${questionId}`);
        setIsBookmarked(true);
      }
    } catch (error) {
      console.error('Error toggling bookmark:', error);
      alert('操作失败，请重试');
    } finally {
      setToggling(false);
    }
  };

  return {
    isBookmarked,
    toggling,
    loading,
    toggleBookmark,
    refresh: checkBookmarkStatus
  };
}

